import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';
import { keys } from 'lodash';
import {
  jobNames as jobNameHelpers,
  selectors as selectorHelpers
} from '../helpers';
import {
  groupJobRelationshipsByParentJobId,
  metricsByJobIds,
  getMetricsPageInfo,
  getMetricsPageLastSelectedJob,
  groupScenariosByDispatcherId
} from '../reducers';

export const getMetricsPageSelectedJobChildMetrics = createCachedSelector(
  groupJobRelationshipsByParentJobId,
  metricsByJobIds,
  getMetricsPageLastSelectedJob,
  selectorHelpers.typeWhenOnCaseOrEngineMetrics,
  (groupJobRelationshipsByParentJobId, metricsByJobIds, selectedJob, onRelevantPage) => {
    if (!onRelevantPage || (!selectedJob || !selectedJob.jobId)) {
      return {};
    }

    // get jobRelationships and diff metrics if it's case metrics page
    // metrics will be empty if it's not case metrics page
    const jobRelationships = groupJobRelationshipsByParentJobId[selectedJob.jobId] || [];
    let metrics = {};
    jobRelationships.forEach(jr => {
      const childMetrics = metricsByJobIds[jr.child_job_id];
      if (childMetrics) {
        metrics = Object.assign(childMetrics, metrics);
      }
    });

    return metrics;
  }
)(
  (state, pageType) => selectorHelpers.typeWhenOnCaseOrEngineMetrics(state, pageType)
);

export const caseActionsScenarioStatusByDispatcher = createSelector(
  metricsByJobIds,
  getMetricsPageInfo,
  groupScenariosByDispatcherId,
  (metricsByJobIds, info, scenarios) => {
    const caseActionsScenarioStatus = {};
    if (info.jobName === jobNameHelpers.PERFORMANCE && info.dispatcherId &&
      Object.keys(scenarios).length > 0)
    {
      const scenarioStatusByRunnerId = {};
      const sens = scenarios[info.dispatcherId];
      let runnerIds = [];
      if (sens)
      {
        runnerIds = runnerIds.concat(sens.map(s => s.runner));
        sens.forEach(
          s => {
            scenarioStatusByRunnerId[s.runner] = s.status;
          }
        );
      }
      runnerIds.forEach(id => {
        const metricKeys = metricsByJobIds[id] ? keys(metricsByJobIds[id]) : [];
        metricKeys.forEach(
          metricsName => {
            if (metricsName.includes('|'))
            {
              caseActionsScenarioStatus[metricsName] = scenarioStatusByRunnerId[id];
            }
          }
        );
      });
    }
    return caseActionsScenarioStatus;
  }
);


// WEBPACK FOOTER //
// src/selectors/metrics.js